module.exports = __webpack_public_path__ + "static/img/top-bottom-icon.bce23e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main_images/top-bottom-icon.png
// module id = /Cv5
// module chunks = 1